<template>
    <layout>
        <TitleLable parentMessage="创建题目" :showback="true"></TitleLable>

        <div class="type_box">
            <span class="trem" v-show="item.value != 8" v-for="(item,index) in type_data" :key="index" @click="clickType(item.value)" :style="change_index == item.value?'background-color:#409eff;color:#ffffff':''">{{ item.name }}</span>
        </div>

        <Choicemultiple v-if="[1,2,3].includes(change_index)" :question_type="change_index" ref="choice" @create="create"></Choicemultiple>

        <Matchquestion v-if="change_index == 4" :question_type="change_index" ref="match" @create="create"></Matchquestion>
        <Wordquestion v-if="change_index == 5" :question_type="change_index" ref="word" @create="create"></Wordquestion>
        <Writequestion v-if="[6,7].includes(change_index)" :question_type="change_index" ref="write" @create="create"></Writequestion>
        <Decidequestion v-if="change_index == 9" :question_type="change_index" ref="decide" @create="create"></Decidequestion>
    </layout>
</template>
<script>
import TitleLable from '../../units/Titlelabel.vue';
import Choicemultiple from '../../units/questions/Choicemultiple.vue';
import Matchquestion from '../../units/questions/Matchquestion.vue';
import Wordquestion from '../../units/questions/Wordquestion.vue';
import Writequestion from '../../units/questions/Writequestion.vue';
import Decidequestion from '../../units/questions/Decidequestion.vue';

import Http from "../../apis/questionbank";
export default {
    components:{
        TitleLable,
        Choicemultiple,
        Matchquestion,
        Wordquestion,
        Writequestion,
        Decidequestion
    },
    data(){
        return{
            change_index:1,
            question_id:'',
            type_data:[
                {
                    value:1,
                    name:'单项选择'
                },
                {
                    value:2,
                    name:'阅读理解'
                },
                {
                    value:3,
                    name:'完型填空'
                },
                {
                    value:4,
                    name:'匹配题'
                },
                {
                    value:5,
                    name:'单词变形'
                },
                {
                    value:6,
                    name:'写作题'
                },
                {
                    value:7,
                    name:'翻译题'
                },
                {
                    value:8,
                    name:'听力题'
                },
                {
                    value:9,
                    name:'判断题'
                }
            ],
        }
    },
    activated(){
        this.question_id = this.$route.query.question_id
    },
    methods:{
        clickType(index){

            this.change_index = index
        },
        create(form){
            form.qid = this.question_id
            Http.createQuestion(form).then((res) => {
                //loading.close()
                this.$message({
                    type: res.code?'success':'error',
                    message:res.msg
                }); 
                if(res.code){
                    if([1,2,3].includes(this.change_index)){
                        this.$refs.choice.clear()
                    }
                    if([6,7].includes(this.change_index)){
                        this.$refs.write.clear()
                    }
                    if(this.change_index == 4){
                        this.$refs.match.clear()
                    }
                    if(this.change_index == 5){
                        this.$refs.word.clear()
                    }
                    if(this.change_index == 9){
                        this.$refs.decide.clear()
                    }
                }
            });
        },
        goBack(){

        }
    }
}
</script>
<style lang="less" scoped>
.type_box{

    display: inline-block;
    width: 100%;
}
.trem{
    color: #409EFF;
    background: #ecf5ff;
    border-color: #b3d8ff;
    padding: 9px 15px;
    font-size: 12px;
    border-radius: 3px;
    display: inline-block;
    margin-right: 10px;
    cursor: pointer;
    margin-bottom: 10px;
}
</style>